import { Box, Tooltip, Typography } from '@mui/material';
import { IconCustomSparkles } from 'components/icons/components/custom/IconCustomSparkles';
import { SocialPostFragmentUseRenderSocialListeningPostVideoFragment } from 'graphql/generated';
import { useEffect, useRef } from 'react';
import { theme } from 'styles/theme';
import {
  HoverPlayableVideo,
  HoverPlayableVideoProps,
  HoverPlayableVideoRef,
} from './HoverPlayableVideo';

export type SocialMediaListeningHoverPlayableVideoProps =
  HoverPlayableVideoProps & {
    post: SocialPostFragmentUseRenderSocialListeningPostVideoFragment;
  };

export const SocialMediaListeningHoverPlayableVideo = ({
  post,
  ...hoverPlayableVideoProps
}: SocialMediaListeningHoverPlayableVideoProps) => {
  const hoverPlayableVideoRef = useRef<HoverPlayableVideoRef>(null);

  useEffect(() => {
    if (!post || !post.socialPostEngagementSuggestions?.[0]?.highlights) {
      return;
    }

    const highlights = post.socialPostEngagementSuggestions[0].highlights;

    hoverPlayableVideoRef.current?.setRenderVideoTimeMarkers(
      highlights.map((highlight) => {
        return {
          timeInSeconds: highlight.start / 1000,
          renderUI: () => (
            <Tooltip
              title={
                <Box
                  sx={{
                    maxWidth: theme.spacing(80),
                    color: theme.colors?.primary.parchment,
                  }}
                >
                  <Typography variant="body-lg">
                    {highlight.highlightSummary}
                  </Typography>
                </Box>
              }
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    transition: 'none',
                    p: 2,
                    borderRadius: theme.spacing(3),
                    background: 'rgba(35, 6, 3, 0.20)',
                    backdropFilter: 'blur(37.5px)',
                  },
                },
              }}
            >
              <Box
                onClick={() => {
                  hoverPlayableVideoRef.current?.seekVideo(
                    highlight.start / 1000,
                  );
                }}
                sx={{
                  cursor: 'pointer',
                  display: 'flex',
                  backgroundColor: 'rgba(35, 6, 3, 0.30)',
                  backdropFilter: 'blur(2px)',
                  borderRadius: theme.spacing(25),
                  p: 1,
                  mb: 1,
                  color: theme.colors?.utility['yellow-1'],
                }}
              >
                <IconCustomSparkles size={14} />
              </Box>
            </Tooltip>
          ),
        };
      }),
    );
  }, [post]);

  return (
    <HoverPlayableVideo
      ref={hoverPlayableVideoRef}
      {...hoverPlayableVideoProps}
    />
  );
};
